<template>
	<router-link v-bind="$attrs" v-if="!bladePage">
		<slot></slot>
	</router-link>
	<a :href="localizedHref" v-bind="$attrs" v-else>
		<slot></slot>
	</a>
</template>

<script setup>
import { computed } from 'vue';
import { useLayoutStore } from '../store/shared/layout-store';

const props = defineProps({
	bladePage: {
		type: Boolean,
		default: false,
	},
	href: {
		type: String,
		default: '',
	},
});
const layoutStore = useLayoutStore();

const localizedHref = computed(() => {
	return `/${layoutStore.lang}${props.href}`;
});
</script>

<style lang="scss" scoped></style>
